import { render, staticRenderFns } from "./TechnicalDoc.vue?vue&type=template&id=48994d9a&scoped=true&"
import script from "./TechnicalDoc.vue?vue&type=script&lang=js&"
export * from "./TechnicalDoc.vue?vue&type=script&lang=js&"
import style0 from "./TechnicalDoc.vue?vue&type=style&index=0&id=48994d9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48994d9a",
  null
  
)

export default component.exports